var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row p-4 text-center justify-content-around align-items-center"
    },
    [
      _c("h3", { staticClass: "col-12 mb-3 display-4 font-weight-medium" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _c(
        "div",
        {
          staticClass: "p-3 col-md-6 mt-2 mt-md-0",
          class: { "order-md-2": _vm.imageToRight }
        },
        [_c("img", { staticClass: "img-fluid", attrs: { src: _vm.imageSrc } })]
      ),
      _c(
        "div",
        {
          staticClass: "col-md-6 mt-2 mt-md-0",
          class: { "order-md-1": _vm.imageToRight }
        },
        [
          _c("p", { staticClass: "section-description" }, [
            _vm._v(_vm._s(_vm.description))
          ]),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center" },
            _vm._l(_vm.buttons, function(button, index) {
              return _c(
                "a",
                {
                  key: index,
                  staticClass: "btn btn-primary section-link mx-2 mb-3",
                  attrs: { role: "button", href: button.href }
                },
                [_vm._v(" " + _vm._s(button.text) + " ")]
              )
            }),
            0
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }